<template>

    <section class="home-header-hero" data-nosnippet>

        <div class="home-header-hero-carousel slick">
			<div v-for="hero in heros">
				<div>
					<div
							class="carousel-item w-100 d-inline-block"
							v-bind:style="{ backgroundImage : 'url(' + teaserImage(hero['acf']) + ')' }"
					>
						<div class="overlay"></div>
						<div class="carousel-caption">
							<h2
									class="heading"
									v-html="hero['acf']['teaser_title']"
									v-bind:class="{
										'heading-black' : hero['acf']['teaser_headline_color'] === 'black',
										'heading-pink' : hero['acf']['teaser_headline_color'] === 'red',
										'heading-white' : hero['acf']['teaser_headline_color'] === 'white',
										'heading-none' : hero['acf']['teaser_headline_color'] === 'none'
									}"
							></h2>
							<p class="action">
								<a :href="'/' + hero['post_name']">
									<button class="btn btn-pink-white ani-btn-hover-scale-bounce">mehr erfahren</button>
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
        </div>

    </section>

</template>

<script>

    // console.log('HomeHeaderHero');

    import env from '../env';

    import scrollHelper from '../services/scrollHelper';
    import wpApi from '../services/wpApi';

    import Vue from 'vue';

    export default {
        created(){
            window.addEventListener('scroll', this.scrollHandler, { passive : true });
            this.load();
        },
        destroyed(){
            window.removeEventListener('scroll', this.scrollHandler);
        },
        mounted(){
            this.scrollHandler();
        },
        components : {},
        data(){
            return {
                heros : [],
                isLoaded : false,
                slickElement : null,
                slickIsSliding : false,
                slickOptions : {
                    arrows : true,
                    autoplay : true,
                    autoplaySpeed : 8000,
                    dots: true,
                    infinite : true,
                    nextArrow : '<button class="carousel-control-next"><span class="carousel-control-next-icon"></span></button>',
                    prevArrow : '<button class="carousel-control-prev"><span class="carousel-control-prev-icon"></span></button>',
                    // responsive : [
                    //     {
                    //         breakpoint : 767,
                    //         settings : {
                    //             arrows : false,
                    //         },
                    //     },
                    // ],
                    slidesToScroll : 1,
                    slidesToShow : 1,
                },
                wpApi
            };
        },
        props : {
            'homeHeaderHeroParams' : {
              default : () => [],
              type : Array,
            }
        },
        methods : {
            load(){
                this.homeHeaderHeroParams.forEach((value)=>{
                  this.heros.push(value['homepage_slider_post'])
                });
                this.isLoaded = true;
            },
            scrollHandler(){
                if (typeof jQuery === 'undefined') return;
                if (typeof $ === 'undefined') $ = jQuery;
                if (!this.slickElement) return;
                if (scrollHelper.isScrolledIntoView(this.$el)) {
                    $(this.slickElement).slick('slickPlay');
                } else {
                    $(this.slickElement).slick('slickPause');
                }
            },
            slickAfterChangeHandler(){
                this.slickIsSliding = false;
            },
            slickBeforeChangeHandler(){
                this.slickIsSliding = true;
            },
            slickInit(){
                // Ensure $ is available - if not but jQuery is, assign it
                if (typeof jQuery === 'undefined') {
                    console.warn('HomeHeaderHero: jQuery not available');
                    return;
                }
                if (typeof $ === 'undefined') {
                    $ = jQuery;
                }
                if (!this.$el || typeof this.$el.querySelector !== 'function') {
                    console.warn('HomeHeaderHero: $el not ready');
                    return;
                }
                if (this.slickElement === null) {
                    this.slickElement = this.$el.querySelector('.slick');
                    if (this.slickElement) {
                        $(this.slickElement).slick(this.slickOptions);
                        $(this.slickElement).on('afterChange', this.slickAfterChangeHandler);
                        $(this.slickElement).on('beforeChange', this.slickBeforeChangeHandler);
                    }
                }
            },
            slickItemClickHandler(route){
                if (this.slickIsSliding === false) {
                    this.$router.push(route);
                }
            },
            teaserImage(acf){

                let teaserImage = '';
                if(acf['teaser_image_960_720'] !== undefined){
                    teaserImage = acf['teaser_image_960_720'];
                }else if(acf['teaser_image_3840_3840'] !== undefined){
                    teaserImage = acf['teaser_image_3840_3840'];
                }

                if (acf['teaser_image_720_720'] !== undefined && window.matchMedia('(min-width: 1200px)').matches) {
                    teaserImage = acf['teaser_image_720_720'];
                }
                else if (acf['teaser_image_3840_1536'] !== undefined && window.matchMedia('(min-width: 1440px)').matches) {
                    teaserImage = acf['teaser_image_3840_1536'];
                }
                else if (acf['teaser_image_3840_3840'] !== undefined && window.matchMedia('(min-width: 1920px)').matches) {
                    teaserImage = acf['teaser_image_3840_3840'];
                }

                if(teaserImage != '')
                {
                    return wpApi.stripHost(teaserImage);
                }
            }
        },
        watch : {
            isLoaded(value){
                if (value) {
                    Vue.nextTick(()=>{
                        this.slickInit();
                    });
                }
            },
        },
    }

</script>

<style lang="scss">

@import '../../css/variables';
.home-header-hero {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	.home-header-hero-carousel {
		height: 100%;
		.carousel-control-next,
		.carousel-control-prev {
			bottom:0;
			top:auto;
			width: 1.5rem + 1.75rem + 1.5rem;
			height: 18.5rem - 5.5rem;
			background: none;
			border: 0 none;
			cursor: pointer;
			outline: none;
			z-index: 1;
			@media screen and (max-width: 767px) {
				display: none !important;
			}
			@media screen and (min-width: 1200px) {
				width: (1.5rem + 1.75rem + 1.5rem) * $factor-1200;
				height: (18.5rem - 5.5rem) * $factor-1200;
			}
			@media screen and (min-width: 1440px) {
				width: (1.5rem + 1.75rem + 1.5rem) * $factor-1440;
				height: (18.5rem - 5.5rem) * $factor-1440;
			}
			@media screen and (min-width: 1920px) {
				width: (1.5rem + 1.75rem + 1.5rem) * $factor-1920;
				height: (18.5rem - 5.5rem) * $factor-1920;
			}
			@media screen and (min-width: 2400px) {
				width: (1.5rem + 1.75rem + 1.5rem) * $factor-2400;
				height: (18.5rem - 5.5rem) * $factor-2400;
			}
			.carousel-control-next-icon,
			.carousel-control-prev-icon {
				width: 1.75rem;
				height: 3.0625rem;
				background-position: 50% 50%;
				background-repeat: no-repeat;
				background-size: 100% 100%;
				@media screen and (min-width: 1200px) {
					width: 1.75rem * $factor-1200;
					height: 3.0625rem * $factor-1200;
				}
				@media screen and (min-width: 1440px) {
					width: 1.75rem * $factor-1440;
					height: 3.0625rem * $factor-1440;
				}
				@media screen and (min-width: 1920px) {
					width: 1.75rem * $factor-1920;
					height: 3.0625rem * $factor-1920;
				}
				@media screen and (min-width: 2400px) {
					width: 1.75rem * $factor-2400;
					height: 3.0625rem * $factor-2400;
				}
			}
			.carousel-control-prev-icon {
				background-image: url(/img/ic_chevron_left_ffffff.svg);
			}
			.carousel-control-next-icon {
				background-image: url(/img/ic_chevron_right_ffffff.svg);
			}
		}
		.carousel-item {
			height: 100%;
			background-position: 50% 0;
			background-repeat: no-repeat;
			background-size: cover;
			outline: none;
			@media screen and (max-width: 767px) {
				background-position: 65% 0;
			}
			.carousel-caption {
				@media screen and (min-width: 768px) {
					display: flex;
					flex-direction: column;
				}
				right: auto;
				bottom: auto;
				left: 1.5rem + 1.75rem + 1.5rem;
				top: 0;
				width: calc(50% - 1.5rem - 1.75rem - 1.5rem - 1.5rem);
				height: 18.5rem + 5.5rem;
				padding: 0;
				padding-top: (1rem + 2rem);
				text-align: left;
				@media screen and (max-width: 767px) {
					left: 1.5rem;
					width: calc(75% - 1.5rem);
					padding-top: 4rem;
					text-align: left;
				}
				@media screen and (min-width: 1200px) {
					left: (1.5rem + 1.75rem + 1.5rem) * $factor-1200;
					width: calc(50% - 1.5rem * #{$factor-1200} - 1.75rem * #{$factor-1200} - 1.5rem * #{$factor-1200} - 1.5rem * #{$factor-1200});
					height: (18.5rem + 5.5rem) * $factor-1200;
					padding-top: (1rem + 2rem) * $factor-1200;
				}
				@media screen and (min-width: 1440px) {
					left: (1.5rem + 1.75rem + 1.5rem) * $factor-1440;
					width: calc(50% - 1.5rem * #{$factor-1440} - 1.75rem * #{$factor-1440} - 1.5rem * #{$factor-1440} - 1.5rem * #{$factor-1440});
					//height: (18.5rem + 5.5rem) * $factor-1440;
					//padding-top: (1rem + 2rem) * $factor-1440;
				}
				@media screen and (min-width: 1920px) {
					left: (1.5rem + 1.75rem + 1.5rem) * $factor-1920;
					width: calc(50% - 1.5rem * #{$factor-1920} - 1.75rem * #{$factor-1920} - 1.5rem * #{$factor-1920} - 1.5rem * #{$factor-1920});
					//height: (18.5rem + 5.5rem) * $factor-1920;
					//padding-top: (1rem + 2rem) * $factor-1920;
				}
				@media screen and (min-width: 2400px) {
					left: (1.5rem + 1.75rem + 1.5rem) * $factor-2400;
					width: calc(50% - 1.5rem * #{$factor-2400} - 1.75rem * #{$factor-2400} - 1.5rem * #{$factor-2400} - 1.5rem * #{$factor-2400});
					//height: (18.5rem + 5.5rem) * $factor-2400;
					//padding-top: (1rem + 2rem) * $factor-2400;
				}
				.action {
					margin: 0 0 auto 0;
				}
				.heading {
					margin: auto 0 1rem 0;
					color: $color-nochvielvor-white;
					font-size: 1.75rem;
					font-weight: bold;
					text-transform: uppercase;
					@media screen and (max-width: 767px) {
						margin: auto 0 1rem * $factor-720 0;
						font-size: 1.75rem * $factor-720;
					}
					@media screen and (min-width: 1200px) {
						margin: auto 0 1rem * $factor-1200 0;
						font-size: 1.75rem * $factor-1200;
					}
					/*@media screen and (min-width: 1440px) {
						margin: auto 0 1rem * $factor-1440 0;
						font-size: 1.75rem * $factor-1440;
					}
					@media screen and (min-width: 1920px) {
						margin: 5.5rem 0 1rem * $factor-1920 0;
						font-size: 1.75rem * $factor-1920;
					}
					@media screen and (min-width: 2400px) {
						margin: 5.5rem 0 1rem * $factor-2400 0;
						font-size: 1.75rem * $factor-2400;
					}*/
					&.heading-black {
						color: $color-nochvielvor-black;
					}
					&.heading-pink {
						color: $color-nochvielvor-pink;
					}
					&.heading-white {
						color: $color-nochvielvor-white;
					}
					&.heading-none {
						display: none;
					}
				}
			}
		}
		.overlay{
			background-color: rgba(0, 0, 0, 0.5);
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
		}
	}
	.slick {
		.slick-list {
			height: 100%;
			.slick-track {
				height: 100%;
				will-change: transform;
				.slick-slide {
					> div {
						height: 100%;
					}
				}
			}
		}
	}
}
$slick-font-path: "/fonts/slick/" !default;
$slick-font-family: "slick" !default;
$slick-dot-color: white !default;
$slick-dot-color-active: $slick-dot-color !default;
$slick-dot-character: "\2022" !default;
$slick-dot-size: 16px !default;
$slick-opacity-default: 0.75 !default;
$slick-opacity-on-hover: 1 !default;
$slick-opacity-not-active: 0.25 !default;

@function slick-font-url($url) {
	@if function-exists(font-url) {
		@return font-url($url);
	}
	@else {
		@return url($slick-font-path + $url);
	}
}
/* Icons */
@if $slick-font-family == "slick" {
	@font-face {
		font-family: "slick";
		src: slick-font-url("slick.eot");
		src: slick-font-url("slick.eot?#iefix") format("embedded-opentype"), slick-font-url("slick.woff") format("woff"), slick-font-url("slick.ttf") format("truetype"), slick-font-url("slick.svg#slick") format("svg");
		font-weight: normal;
		font-style: normal;
	}
}

.home-header-hero .slick-dots {
	bottom: 21px;
	@media screen and (min-width: 768px) {
		bottom: 35px;
	}
	li {
		button {
			&:hover, &:focus {
				outline: none;
				&:before {
					opacity: $slick-opacity-on-hover;
				}
			}
			&:before {
				font-size: $slick-dot-size;
				color: $slick-dot-color;
				-webkit-font-smoothing: antialiased;
				-moz-osx-font-smoothing: grayscale;
			}
		}
		&.slick-active button:before {
			color: $slick-dot-color-active;
		}
	}
}

</style>
